<template>
  <svg :width="size" :height="size * 0.86" viewBox="0 0 44 38" aria-hidden="true">
    <!-- Wavy 4-pane flag homage: red / green / blue / yellow -->
    <g stroke="#1a1a1a" stroke-width="1.4">
      <path d="M2 6 Q12 2 21 6 L21 18 Q12 14 2 18 Z" fill="#f65314" />
      <path d="M23 6 Q32 2 42 6 L42 18 Q32 14 23 18 Z" fill="#7cbb00" />
      <path d="M2 20 Q12 16 21 20 L21 32 Q12 28 2 32 Z" fill="#00a1f1" />
      <path d="M23 20 Q32 16 42 20 L42 32 Q32 28 23 32 Z" fill="#ffbb00" />
    </g>
  </svg>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ size?: number }>(), { size: 22 })
</script>
